import { app } from '../../../../bootstrap/core';
import { ticketTableHeaderComponent } from './ticketTableHeader.component';
import { TicketLists, RelevantTicketStatesForTransferring, RelevantTicketStatesForReceiving, SearchSuggestions } from './ticketTableHeader.constants';
import SearchSuggestTemplate from './partials/search.suggest.tpl.html';

app.component('ticketTableHeader', ticketTableHeaderComponent);
app.constant('TicketLists', TicketLists);
app.constant('SearchSuggestions', SearchSuggestions);
app.constant('SearchSuggestTemplate', SearchSuggestTemplate);
app.constant('RelevantTicketStatesForTransferring', RelevantTicketStatesForTransferring);
app.constant('RelevantTicketStatesForReceiving', RelevantTicketStatesForReceiving);
